import React from 'react';

// variant: primary (azul-marinho) | accent (verde-limão) | outline | ghost | danger
export function Button({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconRight: IconRight,
  block = false,
  className = '',
  children,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={`ss-btn ss-btn--${variant} ss-btn--${size} ${block ? 'ss-btn--block' : ''} ${className}`}
      {...props}
    >
      {Icon && <Icon size={size === 'sm' ? 15 : 18} strokeWidth={2.2} aria-hidden="true" />}
      {children && <span>{children}</span>}
      {IconRight && <IconRight size={size === 'sm' ? 15 : 18} strokeWidth={2.2} aria-hidden="true" />}
    </button>
  );
}

// Upload de arquivo com aparência de botão.
export function FileButton({ variant = 'outline', size = 'md', icon: Icon, accept, onChange, className = '', children }) {
  return (
    <label className={`ss-btn ss-btn--${variant} ss-btn--${size} ${className}`}>
      {Icon && <Icon size={size === 'sm' ? 15 : 18} strokeWidth={2.2} aria-hidden="true" />}
      <span>{children}</span>
      <input type="file" accept={accept} onChange={onChange} hidden />
    </label>
  );
}

// Link com aparência de botão (ex.: abrir PDF em nova aba).
export function LinkButton({ variant = 'outline', size = 'md', icon: Icon, className = '', children, ...props }) {
  return (
    <a className={`ss-btn ss-btn--${variant} ss-btn--${size} ${className}`} {...props}>
      {Icon && <Icon size={size === 'sm' ? 15 : 18} strokeWidth={2.2} aria-hidden="true" />}
      <span>{children}</span>
    </a>
  );
}
